import React from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
import moment from 'moment';

import { AddressSplit } from '../services/utilities/AddressSplit';
import FieldApi from '../services/field/FieldApi';
import FieldService from '../services/field/FieldService';
import FieldCcusApi from '../services/FieldCcus';
import SessionStorageService from '../services/utilities/SessionStorageService';
import LocalStorageService from '../services/utilities/LocalStorageService';
import { FieldService as FieldServices } from '../services/Fields';
import { CompanyService } from '../services/Companies';

import * as FormEle from '../components/FieldFormElements';
import * as FormEleCcus from '../components/FieldFormElementsCcus';
import { FieldFormElementsReadOnly } from '../components/FieldFormElementsReadOnly';
import { Confirmation, Information } from '../components/modals/common/';
import { Modal } from '../components/Modal';
import { DialogSuccessError } from '../components/modals/DialogSuccessError';
import { BankenInfoDialog } from '../components/modals/BankenInfoDialog';
import { FieldFormCcusCheckbox } from '../components/FieldFormCcusCheckbox';
import { FieldCcusForm } from '../components/forms/FieldCcusForm'; // Ccusフォーム
import { ccusStore } from '../components/FieldFormElementsCcusProvider'; // Ccusフォーム
import {
  FieldCcusRegisterDialog,
  FieldCcusRegisterDialogPromise,
  CcusRegisterDialogProvider,
} from '../components/modals/FieldCcusRegisterDialog';
import {
  Form,
  createFormEventManager,
  SwitchForm,
} from '../components/FormBase';

import _masterSlideLoader from '../utilities/masterSlideLoader';
import { validationByJoi } from '../utilities/commonValidation';
import {
  FieldScheme,
  FieldCcusScheme,
  FieldCopyScheme,
} from '../utilities/JoiSchemes';
import { isTargetRoleId } from '../utilities/roleUtility';
import { messageUtility } from '../utilities/messageUtility';
import {
  USER_ROLES,
  HEADER_CONSTANTS,
  LOCK_MAX_DAYS,
  CCUS_ORDER_TYPE,
  CCUS_CONSTRUCTURE_TYPE,
  PREFECTURE_GROUPS,
  CONTRACT_FLAG,
  PAGE_REFERER,
  SESSION_KEY_ITEM,
  DATE_TIME_FORMAT,
  FIELD_WORK_HOUR_ZONES,
  API_FLAG,
  APPROVAL_STATUS,
  COPY_FIELD_ADDRESS_TARGET,
} from '../utilities/constants';

import fetchMg from '../utilities/fetchManager';
import { isApiFlagOn, matchFormatDateSlash } from '../utilities/commonUtil';
import { MasterPageHeader } from '../components/PageHeader';
import {
  FormList,
  FormListSubHeader,
  FormListItem,
} from '../components/CommonFormComponents';
import { CcusTitleBlock } from '../components/CcusFormComponent';
import dialogLoader from '../utilities/dialogLoader';
import { CloseEditView } from '../components/CloseEditView';
import { FieldNaviList } from '../components/list/FieldNaviList';
import SystemUseHistoryDialog from '../components/dialogs/SystemUseHistoryDialog';
import { CancelAndConfirmDialog } from '../components/modals/CancelAndConfirmDialog';
import { Description } from '../components/Description';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { scrollToElem } from '../utilities/scrollToElem';

moment.locale('ja');

// ダイアログ名
const DIALOG_NAME = {
  update: 'update', // 現場更新
  delete: 'delete', // 現場削除
  banken: 'banken', //
};

// http://localhost:3000/conference/0/FieldForm:1/0/0/0 で開く
/**
 * @description 現場編集画面
 */
export class FieldsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validate: {}, // バリエーションメッセージを格納
      params: {}, // 現場情報を保持
      company: {}, //元請会社情報を保持
      jvsParams: [], // FormBase用JV情報を保持
      ccus_field_id: null, //ccus現場id
      ccus_disable_checkbox: false, //ccus情報取得
      ccus_register_flg: false, //CCUS登録フラグ
      ccus_field_data: {
        field: {},
        ccus_field_id: null,
        ccus_field_managers: {},
      }, //CCUS情報を格納
      ccus_field_data_flag: false, //ccus情報の保持フラグ
      beforePageReferer: null,
      isCcusRequiredShow: true,
      fieldCreatedAt: null,
      fieldUpdatedAt: null,
      visibleDialogName: null, // 開閉用ダイアログ名
      workHourZoneOnChangeCheckDialogShow: false,
      beforeUsageEndDate: null, // 変更前Buildee利用終了日
      companyName: '',
      copyFieldAddress: false,
      disabledCooperationCcus: true,
      visibleSystemUseHistoryDialog: false,
      systemUseHistoryList: [],
      roanToChoseiFlg: false, // 労安からの遷移先が直接「現場詳細」か、黒メニュー「現場一覧」経由かを区別するフラグ
      ccusSecededFlag: false,
      defaultCompleteDate: '',
      defaultGroundbreakingDate: '',
      messageDateDialog: '',
      isWarningGroundbreakingDate: false,
      isWarningCompleteScheduleDate: false,
    };

    this.ccus_field_to_be_check = [
      'ordering_type_id',
      'construction_type_id',
      'manager_id',
    ];

    this.submittingFlag = false; // 多重更新防止Flag
    this.updatingFlag = false; // 更新ボタン連打防止Flag
    this.isRequestingFlag = false;

    // Form で使うEventManagerを取得
    this.FormEventMg = createFormEventManager();

    this.role_id = LocalStorageService.getRoleId(); // ロールID
    this.fieldDelete = this.fieldDelete.bind(this); // 現場削除
    this.handleUpdate = this.handleUpdate.bind(this); // 現場更新
    this.handleWorkHourZoneOnChangeCheck = this.handleWorkHourZoneOnChangeCheck.bind(
      this
    ); // 作業時間帯利用フラグ変更時チェック
    this.handleVisibleDialog = this.handleVisibleDialog.bind(this); // ダイアログ開閉設定

    // slideLoaderからの情報を取得
    if (props.view) {
      this.field_id = props.view.state.id;
    }

    //個々のバリデートをうけとる
    this.FormEventMg.addEventListener('update_validate', this.eachValidate);
    this.FormEventMg.addEventListener('change_value', (id, params) => {
      if (!Object.keys(params).length) {
        return;
      }
      const newValue = {};
      if (this.state.params.ccus_site_id) {
        if (id === 'groundbreaking_date') {
          newValue.isWarningGroundbreakingDate = moment(
            params.groundbreaking_date
          ).isBefore(moment(this.state.defaultGroundbreakingDate), 'day');
        } else if (id === 'complete_schedule_date') {
          newValue.isWarningCompleteScheduleDate = moment(
            params.complete_schedule_date
          ).isAfter(moment(this.state.defaultCompleteDate), 'day');
        }
      }
      this.setState({
        params: { ...this.state.params, ...params },
        ...newValue,
      });
    });

    this.state.roanToChoseiFlg = SessionStorageService.getRoanToChoseiFlg();
    if (this.state.roanToChoseiFlg) {
      // 労安側からの遷移の場合
      // 労務安全から遷移してくる場合、対象の現場はすでに承認済みであり現場詳細画面を表示すべきであるため、
      // 前回表示画面（beforePageReferer）を現場一覧として扱うことにより後続処理で現場詳細画面の表示に切り替える
      this.state.beforePageReferer = PAGE_REFERER.fields.key;
    } else {
      this.state.beforePageReferer = SessionStorageService.getItem(
        SESSION_KEY_ITEM.beforePageName
      );
    }

    if (this.state.beforePageReferer === PAGE_REFERER.fieldRequestList.key) {
      this.state.isCcusRequiredShow = false;
    }

    // buildeeとの契約無しの状態で、URL直叩き遷移防止処理
    const contractFlag = SessionStorageService.getContractFlag();
    if (
      contractFlag === CONTRACT_FLAG.noContract.id &&
      isTargetRoleId([USER_ROLES.branch, USER_ROLES.manager], this.role_id)
    ) {
      return window.location.replace('/error-permission');
    }

    SessionStorageService.removeRoanToChoseiFlg();
  }

  getCcusSecededFlag = () => {
    CompanyService.getCompaniesCcusSecededFlag().then(response => {
      const ccusSecededFlag = _.get(response, 'data.entities.ccus_seceded_flag');
      this.setState({ ccusSecededFlag });
    });
  };

  /**
   * @description BLDE_V2-48023 BANKEN案内ダイアログを表示させる条件チェック
   * @returns {boolean} すべての条件を満たせばtrue、そうでなければfalse
   */
  shouldShowBankenDialog = () => {
    // 入退場管理フラグがONの場合
    const useEntranceFlagIsOn =
      this.state.params.use_entrance_flg === API_FLAG.On;
    // OFFからONに変更された場合のみ
    const useEntranceFlagWasOff =
      this.state.use_entrance_flg_on_load === API_FLAG.Off;
    // 申請の編集画面は対象外
    const beforePageWasNotFieldRequestList =
      this.state.beforePageReferer !== PAGE_REFERER.fieldRequestList.key;
    // Buildee担当者が変更された場合は表示させない
    const sameBuildeeUser = this.state.buildee_user_id_on_load === this.state.params.buildee_user_id;
    // Buildee利用終了後は表示させない
    const usageHasNotEnded = moment(this.state.params.usage_end_date, 'YYYY/MM/DD').isAfter(moment(), 'day');

    return (
      useEntranceFlagIsOn &&
      useEntranceFlagWasOff &&
      beforePageWasNotFieldRequestList &&
      sameBuildeeUser &&
      usageHasNotEnded
    );
  };

  UNSAFE_componentWillMount() {
    this.onLoad();
  }

  componentWillUnmount() {
    this.FormEventMg.deleteEvent('change_value');
    this.FormEventMg.deleteEvent('input_change_value');
    this.FormEventMg.deleteEvent('update_validate');
  }

  /**
   * 現場編集か現場申請編集かのタイトル文字列を返す
   * @param {boolean} roanToChoseiFlg true: 労安からの遷移先が直接「現場詳細」, false: 労安からの遷移先が黒メニュー「現場一覧」経由
   * @param {string} beforePageReferer 直前に表示した画面名
   * @return {string} 画面表示用の文字列
   */
  getTitleName = (roanToChoseiFlg, beforePageReferer) => {
    let title = '';
    if (roanToChoseiFlg || beforePageReferer === PAGE_REFERER.fields.key) {
      // 労務安全から直接遷移もしくは現場一覧から遷移した場合、現場編集
      title = data.pageTitle.fieldEdit;
    } else if (beforePageReferer === PAGE_REFERER.fieldRequestList.key) {
      // 現場申請一覧から遷移した場合、現場申請編集
      title = data.pageTitle.fieldRequestEdit;
    }
    return title;
  };

  /**
   * 一つ前の画面名を返す
   * @param {boolean} roanToChoseiFlg true: 労安からの遷移先が直接「現場詳細」, false: 労安からの遷移先が黒メニュー「現場一覧」経由
   * @param {string} beforePageReferer 直前に表示した画面名
   * @return {string} リンクの文字列
   */
  getBeforePageName = (roanToChoseiFlg, beforePageReferer) => {
    let name = '';
    if (roanToChoseiFlg || beforePageReferer === PAGE_REFERER.fields.key) {
      // 労務安全から直接遷移もしくは現場一覧から遷移した場合、現場詳細
      name = data.pageTitle.fieldDetail;
    } else if (beforePageReferer === PAGE_REFERER.fieldRequestList.key) {
      // 現場申請一覧から遷移した場合、現場申請詳細
      name = data.pageTitle.fieldRequestDetail;
    }
    return name;
  };

  /**
   * @description 現場情報をロードする
   */
  onLoad() {
    const stateValue = _.cloneDeep(this.state);
    FieldApi.loadField(this.field_id)
      .then(response => {
        if (response.result) {
          //APIでccusと連携するまでダミー情報入れる
          stateValue.params = _.cloneDeep(response.data.entities.field);
          stateValue.defaultGroundbreakingDate =
            stateValue.params.groundbreaking_date;
          stateValue.defaultCompleteDate =
            stateValue.params.complete_schedule_date;
          stateValue.beforeUsageEndDate =
            response.data.entities.field.usage_end_date;

          stateValue.companyName = stateValue.params.name;
          stateValue.buildee_user_id_on_load =
            stateValue.params.buildee_user_id;

          //文字列として入力チェックするため、文字列化しておく
          stateValue.params.start_day = String(stateValue.params.start_day);
          stateValue.params.approval_days = String(
            stateValue.params.approval_days
          );
          // Trigger input change value for usage_end_date
          this.FormEventMg.trigger('input_change_value', {
            id: 'usage_end_date',
            value: response.data.entities.field.usage_end_date,
          });

          //addressがあれば住所を分割
          if (
            (stateValue.params.address !== null ||
              stateValue.params.address !== undefined) &&
            (stateValue.params.address_prefecture === null ||
              stateValue.params.address_prefecture === undefined)
          ) {
            const _address = AddressSplit(stateValue.params.address);
            if (_address) {
              stateValue.params.address_prefecture =
                stateValue.params.address_prefecture || _address.prefecture;
              stateValue.params.address_city =
                stateValue.params.address_city || _address.other;
            }
          }

          // URL直接遷移時などbeforePageRefererが特定できないときのみapproval_flagで確認する
          if (
            !this.state.beforePageReferer &&
            _.has(response.data.entities.field, 'approval_flag')
          ) {
            switch (response.data.entities.field.approval_flag) {
              case APPROVAL_STATUS.approval.id:
                stateValue.beforePageReferer = PAGE_REFERER.fields.key;
                SessionStorageService.setItem(
                  SESSION_KEY_ITEM.beforePageName,
                  PAGE_REFERER.fields.key
                );
                break;
              case APPROVAL_STATUS.unapproved.id:
                stateValue.beforePageReferer =
                  PAGE_REFERER.fieldRequestList.key;
                SessionStorageService.setItem(
                  SESSION_KEY_ITEM.beforePageName,
                  PAGE_REFERER.fieldRequestList.key
                );
                break;
              default:
                break;
            }
          }

          //office_addressがあれば住所を分割
          if (
            (stateValue.params.office_address !== null ||
              stateValue.params.office_address !== undefined) &&
            (stateValue.params.office_address_prefecture === null ||
              stateValue.params.office_address_prefecture === undefined)
          ) {
            const _address = AddressSplit(stateValue.params.office_address);
            if (_address) {
              stateValue.params.office_address_prefecture =
                stateValue.params.office_address_prefecture ||
                _address.prefecture;
              stateValue.params.office_address_city =
                stateValue.params.office_address_city || _address.other;
            }
          }

          _.each(stateValue.params.jvs, param => {
            stateValue.jvsParams.push({
              company_id: param.company_id,
              company_name: param.company_name,
              company_branch_id: param.company_branch_id,
              company_branch_name: param.company_branch_name,
              address: param.address,
            });
          });

          stateValue.company = stateValue.params.company;
          stateValue.company_branch = {
            id: stateValue.params.company.company_branch_id,
            name: stateValue.params.company.company_branch_name,
          };
          stateValue.fieldCreatedAt = stateValue.params.created_at;
          stateValue.fieldUpdatedAt = stateValue.params.overall_updated_at;
          //現場監督ならbuildee_user_idを設定
          if (isTargetRoleId([USER_ROLES.manager], this.role_id)) {
            this.FormEventMg.trigger('input_change_value', {
              id: 'buildee_user_id',
              value: stateValue.params.buildee_user_id,
            });
          }

          //ccus現場IDがあればチェックボックスを非活性
          stateValue.ccus_field_data.ccus_field_id =
            stateValue.params.ccus_site_id;
          if (
            stateValue.ccus_field_data.ccus_field_id !== undefined &&
            stateValue.ccus_field_data.ccus_field_id !== null &&
            stateValue.ccus_field_data.ccus_field_id !== ''
          ) {
            stateValue.ccus_disable_checkbox = true;
          }

          // 入退場管理システム/労務安全システムの使用フラグパラメータ
          // use_gk_flg === use_entrance_flg
          // use_roan_flg === use_greenfile_flg
          // 前者から後者に移行されるため、2020/08/13 現在は同じ値が送られているが
          // 前者は不要なので削除する
          if (!_.isUndefined(stateValue.params.use_gk_flg)) {
            delete stateValue.params.use_gk_flg;
          }
          if (!_.isUndefined(stateValue.params.use_roan_flg)) {
            delete stateValue.params.use_roan_flg;
          }

          // 選択予定の支店情報を取得して、
          // 入退場管理機能/労務安全機能のON/OFF Enabled/Disabled 制御を行う
          const params = {
            company_branch_id: stateValue.company_branch.id,
          };
          return fetchMg
            .GetAjax('/api/private/company_branches/list', params)
            .then(response => {
              if (response.result === false) {
                throw new Error('FieldsForm.jsx onLoad after GetAjax');
              }
              // 参照：BLDE_V2-22844 【A-229】ユーザーによる労安・入退場のON/OFF切替(9月末分)
              //        具体的な対応内容（調整会議）
              const {
                available_entrance_flg,
                available_greenfile_flg,
                available_progress_flg,
                cannot_off_greenfile_flg,
              } = response.data.entities.company_branches[0];
              stateValue.params.changeable_entrance_flg =
                available_entrance_flg === true;
              stateValue.params.use_entrance_flg =
                available_entrance_flg === false
                  ? API_FLAG.Off
                  : available_entrance_flg === true
                  ? stateValue.params.use_entrance_flg
                  : null;
              stateValue.params.changeable_greenfile_flg =
                available_greenfile_flg === true;
              stateValue.params.use_greenfile_flg =
                available_greenfile_flg === false
                  ? API_FLAG.Off
                  : available_greenfile_flg === true
                  ? stateValue.params.use_greenfile_flg
                  : null;
              stateValue.params.changeable_progress_flg =
                available_progress_flg === true;
              stateValue.params.use_progress_flg =
                available_progress_flg === false
                  ? API_FLAG.Off
                  : available_progress_flg === true
                  ? stateValue.params.use_progress_flg
                  : null;
              stateValue.use_entrance_flg_on_load =
                stateValue.params.use_entrance_flg;
              stateValue.params.cannot_off_greenfile_flg = cannot_off_greenfile_flg;
            });
        } else {
          alert(response.message);
        }
      })
      .catch(error => {
        alert(error);
      })
      .finally(() => {
        this.setState(stateValue, () => {
          this.onLoadPermissionFieldTreeCooperation();
          this.getCcusSecededFlag();
        });
      });
  }

  /**
   * @description load permission field tree cooperation with ccus
   */
  onLoadPermissionFieldTreeCooperation = () => {
    if (_.isEmpty(_.get(this.state, 'ccus_field_data.ccus_field_id'))) {
      return this.setState({
        disabledCooperationCcus: true,
      });
    }

    FieldCcusApi.checkPermissionFieldTreeCooperationWithCcus(
      this.field_id
    ).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        disabledCooperationCcus: !_.get(
          response,
          'data.entities.enable_ccus_flag'
        ),
      });
    });
  };

  /***
   * @description 各バリデーション系メソッドに遷移させ、エラーメッセージをセット
   * @param {object} values id: 入力フォームID, params: 全入力パラメータ
   */
  eachValidate = values => {
    const { id, params, ccusChecked } = values;

    this.workTimeInputCheck(params.work_hour);

    let result = validationByJoi(
      //ccus登録でスキーマを切り替え
      this.state.ccus_register_flg ? FieldCcusScheme : FieldScheme,
      params
    );
    const _validate = _.cloneDeep(this.state.validate);
    result = this.checkValidate(result, params);

    if (result.status === false && !_.isEmpty(result.messages[id])) {
      // 入力項目に誤りがある場合、エラーメッセージをセット
      _validate[id] = result.messages[id];
    } else {
      // 正常に入力している場合、エラーメッセージを削除
      delete _validate[id];
    }

    if (_.has(result.messages, 'work_hour_type')) {
      // 作業時間帯を1つもチェックしていない場合、エラーメッセージをセット
      _validate.work_hour_type = result.messages.work_hour_type;
    } else {
      // 作業時間帯を1つ以上チェックしている場合、エラーメッセージを削除
      delete _validate.work_hour_type;
    }

    if (id === 'complete_schedule_date' && params['groundbreaking_date']) {
      result.messages.groundbreaking_date
        ? (_validate.groundbreaking_date = result.messages.groundbreaking_date)
        : delete _validate.groundbreaking_date;
    }

    if (ccusChecked === false) {
      _.each(this.ccus_field_to_be_check, field => {
        delete _validate[field];
      });
    }

    this.setState({ validate: _validate });
  };

  /**
   * @description 1日あたりの労働時間（作業員, 社員時間）フォーム入力チェック
   * @param {object} work_hour 1日あたりの労働時間入力パラメータ
   * @returns バリデーションチェック処理後の全入力パラメータオブジェクト
   */
  workTimeInputCheck(work_hour) {
    // 選択後、未選択に切り替えていた場合、要素を削除
    _.each(work_hour, param => {
      if (param.worker_work_time === 'false') {
        delete param.worker_work_time;
      }
      if (param.manager_work_time === 'false') {
        delete param.manager_work_time;
      }
    });
  }

  /***
   * @description 詳細な相関バリデーションチェック
   * @param {object} result Joiで取得したエラーメッセージ
   * @param {object} params 全入力パラメータ
   * @returns バリデーションチェック後のエラーメッセージオブジェクト
   */
  checkValidate = (result, params) => {
    result.messages = result.messages || {};

    if (
      matchFormatDateSlash(params.usage_end_date) &&
      params.usage_end_date !== this.state.beforeUsageEndDate
    ) {
      if (
        moment(params.usage_end_date, 'YYYY/MM/DD').isBefore(moment(), 'day')
      ) {
        result.status = false;
        result.messages.usage_end_date =
          '今日よりあとの日付を入力してください。';
      }
    }

    if (params.groundbreaking_date || params.complete_schedule_date) {
      if (
        moment(params.groundbreaking_date, 'YYYY/MM/DD').isAfter(
          moment(params.complete_schedule_date, 'YYYY/MM/DD')
        )
      ) {
        result.status = false;
        result.messages['groundbreaking_date'] =
          '着工日は竣工予定日以前の日付を入力してください';
      } else {
        params.groundbreaking_date &&
          delete result.messages['groundbreaking_date'];
      }
    }

    const keys = [
      'work_hour_zone_day_flag',
      'work_hour_zone_night_flag',
      'work_hour_zone_midnight_flag',
    ];
    _.remove(keys, function(flag) {
      return !params[flag];
    });
    if (keys.length === 0) {
      result.status = false;
      result.messages.work_hour_type = messageUtility.getMessage('E-000-008');
    }
    for (let i in keys) {
      let key = keys[i];
      if (params[key]) {
        let _key = key.match(/(_night|_midnight)/);
        _key = _key ? _key[1] : '';
        let res = this.checkTimeSelectValue(params, _key);
        _.each(res, item => {
          result.status = false;
          result.messages[item] = '値を選択してください。';
        });
      }
    }

    if (_.isArray(params.work_hour)) {
      result.messages.work_hour = result.messages.work_hour || {};
      const hour = params.work_hour;
      for (let i = 0; i < hour.length; i += 1) {
        if (
          hour[i + 1] &&
          moment(hour[i + 1].start_date, 'YYYY/MM/DD').isSameOrBefore(
            moment(hour[i].start_date, 'YYYY/MM/DD')
          ) // 下の開始日が上より前だったら
        ) {
          if (result.messages.work_hour[i + 1]) {
            result.messages.work_hour[i + 1].start_date =
              '前の適用開始日より後の日付にしてください。';
          } else {
            result.messages.work_hour[i + 1] = {
              start_date: '前の適用開始日より後の日付にしてください。',
            };
          }
          result.status = false;
        }
      }

      if (_.isEmpty(result.messages.work_hour)) {
        delete result.messages.work_hour;
      }
    }

    if (!_.isUndefined(params.approval_days)) {
      // 自動ロックまでの日数が入力されている場合
      result.messages.approval_days = result.messages.approval_days || {};
      const inputDays = Number(params.approval_days);
      if (!_.isEmpty(result.messages.approval_days)) {
        // 半角数字以外を入力した場合
        result.status = false;
        result.messages.approval_days = '半角数字を入力してください。';
      } else if (inputDays > LOCK_MAX_DAYS) {
        // LOCK_MAX_DAYSで指定された日数を超えた場合
        result.status = false;
        result.messages.approval_days = `${String(
          LOCK_MAX_DAYS
        )}日以下で入力して下さい。`;
      }

      if (_.isEmpty(result.messages.approval_days)) {
        delete result.messages.approval_days;
      }
    }

    if (params.jvs) {
      result.messages.jvs = result.messages.jvs || {};

      let branch_ids = _.map(
        params.jvs,
        jv => `${jv.company_id}-${jv.company_branch_id}`
      );

      _.each(branch_ids, (id, i) => {
        if (branch_ids.indexOf(id) !== i) {
          result.messages.jvs[i] = '同じ支店は選択できません。';
          result.status = false;
        }
      });

      if (_.isEmpty(result.messages.jvs)) {
        delete result.messages.jvs;
      }
    }

    return result;
  };

  /***
   * @description 作業時間帯時刻バリデーションチェック
   * @param {object} params 全入力パラメータ
   * @param {string} type 検索用キータイプ
   * @returns 未入力の作業時間帯時刻配列
   */
  checkTimeSelectValue(params, type = '') {
    const result = [];
    const keys = [
      'work_copy_time',
      'work_end_time',
      'work_start_time',
      'earlytime_end',
      'overtime_start',
    ];

    for (let i in keys) {
      const key = `${keys[i]}${type}`;
      if (
        params[key] === 'false' ||
        (!this.state.params[key] && _.isUndefined(params[key]))
      ) {
        result.push(key);
      }
    }

    return result;
  }

  /**
   * @description ccusの値をステートに保持
   * @param {object} data
   */
  setCcusFieldData(data) {
    const stateValue = _.cloneDeep(this.state);
    stateValue.ccus_field_data = _.cloneDeep(data);
    if (
      stateValue.ccus_field_data.ccus_field_id !== undefined &&
      stateValue.ccus_field_data.ccus_field_id !== null &&
      stateValue.ccus_field_data.ccus_field_id !== ''
    ) {
      stateValue.ccus_disable_checkbox = true;
      stateValue.ccus_register_flg = false;
    } else {
      stateValue.ccus_disable_checkbox = false;
    }
    this.setState(stateValue, () => {
      _.each(this.ccus_field_to_be_check, id => {
        this.eachValidate({
          id,
          params: this.state.params,
          ccusChecked: false,
        });
      });
    });
  }

  prefectureKana(name) {
    const _prefecture = _.filter(
      _.flatten(
        _.map(PREFECTURE_GROUPS, region => {
          return _.values(region.prefectures);
        })
      ),
      prefecture => {
        return prefecture.name === name;
      }
    )[0];
    return _prefecture.kana;
  }

  validateCopyFieldAddress = () => {
    const schemaResult = validationByJoi(FieldCopyScheme, this.state.params);
    const result = this.checkValidate(schemaResult, this.state.params);
    let { validate } = _.cloneDeep(this.state);
    const validated = _.filter(COPY_FIELD_ADDRESS_TARGET, input => {
      return !_.has(result.messages, input);
    });
    validate = _.omit(validate, validated);
    // 事務所情報のバリデーションが成功された場合、既存のthis.state.validateから削除する
    // 事務所情報のバリデーションで失敗した項目をthis.state.validateに統合する
    validate = {
      ...validate,
      ...result.messages,
    };
    this.setState({ validate });
  };

  validate = params => {
    const result = validationByJoi(
      this.state.ccus_register_flg ? FieldCcusScheme : FieldScheme,
      params
    );
    const _result = this.checkValidate(result, params);
    if (!_result.status) {
      this.setState({ validate: _result.messages });
      return false;
    } else {
      return true;
    }
  };

  /**
   * @description 入力した値を送信する
   * @param {object} params 全入力パラメータ
   */
  submit = async params => {
    // 多重更新防止
    if (this.submittingFlag) {
      return;
    }
    this.submittingFlag = true;

    this.workTimeInputCheck(params.work_hour);

    /**
     * @TODO: https://e-reverse.backlog.jp/view/BLDE_V2-11720
     * 暫定対応：必要なパラメーターを確認し、Serviceでパラメーターを作成する
     */
    params.address_add_2 = FieldService.getPropertyValue(
      params,
      'address_add_2'
    );
    params.address_add_2_kana = FieldService.getPropertyValue(
      params,
      'address_add_2_kana'
    );
    params.office_address_add_2 = FieldService.getPropertyValue(
      params,
      'office_address_add_2'
    );
    params.office_address_add_2_kana = FieldService.getPropertyValue(
      params,
      'office_address_add_2_kana'
    );

    // Buildee利用終了日
    params.usage_end_date = this.state.params.usage_end_date;
    // この項目はEventMgの仕組みに乗っていないので、
    // submit(params)に値が入ってこないため
    // ここでstateから代入している

    //ccus登録でスキーマを切り替え

    if (this.validate(params) === true) {
      if (!_.has(params, 'department')) {
        // 部署が設定されていない場合
        params.department = '';
      }
      if (!_.has(params, 'postal_code')) {
        params.postal_code = '';
      }
      params.ccus_register_flg = this.state.ccus_register_flg;

      //都道府県のカナを設定
      params.address_prefecture_kana = this.prefectureKana(
        params.address_prefecture
      );
      params.office_address_prefecture_kana = this.prefectureKana(
        params.office_address_prefecture
      );

      // TODO FieldServiceにupdate用のparams作成メソッドを作る時に一緒に移植する
      // CCUS現場IDを取得していれば格納する
      if (
        this.state.ccus_field_data.ccus_field_id !== undefined &&
        this.state.ccus_field_data.ccus_field_id !== null
      ) {
        params.ccus_site_id = this.state.ccus_field_data.ccus_field_id;
      }

      // 入退場管理システムと労務安全システムの値は
      // <Form> や <FormItem> から独立しているので
      // ここの async submit(params) の引数 params には値が入らないため
      // stateの値から params に設定する必要がある
      params.use_entrance_flg = this.state.params.use_entrance_flg;
      params.use_greenfile_flg = this.state.params.use_greenfile_flg;
      params.use_progress_flg = this.state.params.use_progress_flg;

      const newState = {};
      let showModal = true;
      FieldApi.updateField(this.field_id, params)
        .then(response => {
          if (response.result) {
            newState.updateSuccess = true;
            newState.updateTitle =
              this.state.beforePageReferer === PAGE_REFERER.fields.key
                ? messageUtility.getMessage('I-000-114')
                : messageUtility.getMessage('I-000-118');
            newState.updateMsg =
              this.state.beforePageReferer === PAGE_REFERER.fields.key
                ? messageUtility.getMessage('I-000-115')
                : messageUtility.getMessage('I-000-119');
          } else {
            newState.updateSuccess = false;

            if (response.message === messageUtility.getMessage('I-000-234')) {
              showModal = false;
              return dialogLoader.show(CancelAndConfirmDialog, {
                title: messageUtility.getMessage('E-001-402'),
                message: messageUtility.getMessage('E-000-072'),
                confirmButtonText: messageUtility.getMessage('I-000-180'),
                cancelButtonText: messageUtility.getMessage('I-000-017'),
                effectiveButtonClassName: 'btn',
                onCancel: () => {
                  this.updatingFlag = false;
                  dialogLoader.close();
                },
                onConfirm: () => {
                  window.location.reload();
                },
              });
            }

            if (response.message === messageUtility.getMessage('E-000-078')) {
              showModal = false;
              return dialogLoader.show(FormInformationDialog, {
                title: messageUtility.getMessage('E-000-077'),
                message: messageUtility.getMessage('E-000-078'),
                onClose: () => {
                  this.updatingFlag = false;
                  dialogLoader.close();
                },
              });
            }

            if (_.includes(response.message, '作業時間帯')) {
              newState.updateTitle = '作業時間帯を削除できません';
              newState.updateSuccess = true;
            } else {
              newState.updateTitle = '';
            }

            if (!_.isNil(response.message)) {
              newState.updateMsg = response.message;
              if (
                response.message ===
                'Buildee担当者に設定されているユーザーが作業終了されています。Buildee担当者を変更してください。'
              ) {
                newState.updateTitle = messageUtility.getMessage('E-001-422');
              }
            } else {
              newState.updateTitle = '';
              newState.updateMsg = messageUtility.getMessage('E-000-005');
            }
          }
        })
        .catch(error => {
          alert(error);
          newState.updateSuccess = false;
          newState.updateMsg = messageUtility.getMessage('E-000-005');
        })
        .finally(() => {
          newState.validate = {};
          newState.showModal = showModal;
          newState.visibleDialogName = null;
          this.submittingFlag = false;
          this.setState(newState);
        });
    } else {
      this.submittingFlag = false;
      // エラーメッセージを表示
      this.setState({ visibleDialogName: null });
      // バリデーションエラーの場合は更新ボタンのブロックを解除
      this.updatingFlag = false;
    }
  };

  /**
   * @description ダイアログ開閉設定
   * @param {string} dialogName ダイアログ名(DIALOG_NAME)
   *                            ※ nullの場合は、ダイアログを閉じる
   */
  handleVisibleDialog(dialogName) {
    this.setState({ visibleDialogName: dialogName });
  }

  /**
   * @description 現場更新
   */
  handleUpdate = async () => {
    // BLDE_V2-37869: 連打防止。正常に成功した場合はブロックしたまま終了
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;
    const params = _.cloneDeep(this.state.params);

    // BLDE_V2-22140
    const newState = {};
    FieldApi.checkForTurnOffWorkHourZoneFlag(this.field_id, {
      work_hour_zone_day_flag: params['work_hour_zone_day_flag'],
      work_hour_zone_night_flag: params['work_hour_zone_night_flag'],
      work_hour_zone_midnight_flag: params['work_hour_zone_midnight_flag'],
    })
      .then(response => {
        if (response.result) {
          if (
            response.data.total === 0 &&
            response.data.entities.has_on_to_off_work_hour_zone_flag
          ) {
            this.handleVisibleDialog(DIALOG_NAME.update);
          } else {
            this.FormEventMg.trigger('submit');
          }
        } else {
          newState.updateSuccess = false;
          if (!_.isEmpty(response.message)) {
            newState.updateMsg = response.message;
          } else {
            newState.updateMsg = messageUtility.getMessage('E-000-005');
          }
          newState.showModal = true;
        }
      })
      .catch(error => {
        alert(error);
        newState.updateSuccess = false;
        newState.updateMsg = messageUtility.getMessage('E-000-005');
        newState.showModal = true;
      })
      .finally(() => {
        this.updatingFlag = false;
        this.setState(newState);
      });
  };

  /**
   * @description 作業時間帯利用フラグ変更時チェック
   */
  async handleWorkHourZoneOnChangeCheck(newProps, targetValue) {
    if (targetValue) {
      return;
    }
    const params = _.cloneDeep(this.state.params);

    const newParam = {};
    newParam[newProps.id] = targetValue
      ? FIELD_WORK_HOUR_ZONES.on.id
      : FIELD_WORK_HOUR_ZONES.off.id;

    // BLDE_V2-22140
    const newState = {};
    FieldApi.checkForTurnOffWorkHourZoneFlag(
      this.field_id,
      _.assign(
        {
          work_hour_zone_day_flag: params['work_hour_zone_day_flag'],
          work_hour_zone_night_flag: params['work_hour_zone_night_flag'],
          work_hour_zone_midnight_flag: params['work_hour_zone_midnight_flag'],
        },
        newParam
      )
    )
      .then(response => {
        if (response.result) {
          if (response.data.entities.will_all_off_field_trees.length > 0) {
            newState.workHourZoneOnChangeCheckDialogShow = true;
            newProps.onUpdate(FIELD_WORK_HOUR_ZONES.on.id);
          }
        } else {
          if (!_.isEmpty(response.message)) {
            newState.updateMsg = response.message;
          } else {
            newState.updateMsg = messageUtility.getMessage('E-000-001');
          }
          newState.showModal = true;
        }
      })
      .catch(error => {
        alert(error);
        newState.updateMsg = messageUtility.getMessage('E-000-001');
        newState.showModal = true;
      })
      .finally(() => {
        this.setState(newState);
      });
  }

  /**
   * @description 現場削除
   */
  fieldDelete() {
    FieldApi.deleteField(this.field_id).then(response => {
      if (response.result === true) {
        _masterSlideLoader.show(this.state.beforePageReferer, { state: {} });
      }
    });
  }

  /**
   * @description ccusにも登録するチェックボックス
   */
  onChangeCcusCheckbox = async () => {
    _.each(this.ccus_field_to_be_check, id => {
      this.eachValidate({
        id,
        params: this.state.params,
        ccusChecked: !this.state.ccus_register_flg,
      });
    });
    if (this.state.ccus_register_flg) {
      this.setState({
        ccus_register_flg: false,
      });
      return;
    }
    const ccus_result = await FieldCcusRegisterDialogPromise.show();
    if (ccus_result) {
      this.setState({
        ccus_register_flg: true,
      });
    } else {
      this.setState({
        ccus_register_flg: false,
      });
    }
  };

  openCloseEditModal = (beforePageReferer, isClose, roanToChoseiFlg) => {
    dialogLoader.show(CloseEditView, {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          if (isClose && roanToChoseiFlg) { // 閉じるボタンが押下され労安側からの遷移フラグが立っている場合、労安側に戻る
            _masterSlideLoader.close();
          } else { // 現場詳細ボタンが押下された場合、又は閉じるボタンが押下され労安側からの遷移フラグが立っていない場合
            if (roanToChoseiFlg) { // 現場詳細ボタンが押下され労安側からの遷移フラグが立っている場合
              SessionStorageService.setRoanToChoseiFlg(roanToChoseiFlg);
            }
            _masterSlideLoader.show('FieldsDetail', {
              state: {
                id: this.field_id,
                pageReferer: beforePageReferer,
              },
            });
          }
          dialogLoader.close();
        },
      },
    });
  };

  copyFieldAddress = () => {
    const params = {
      office_postal_code: this.state.params.postal_code,
      office_address_prefecture: this.state.params.address_prefecture,
      office_address_prefecture_kana: this.state.params.address_prefecture_kana,
      office_address_city: this.state.params.address_city,
      office_address_city_kana: this.state.params.address_city_kana,
      office_address_add_1: this.state.params.address_add_1,
      office_address_add_1_kana: this.state.params.address_add_1_kana,
      office_address_add_2: this.state.params.address_add_2,
      office_address_add_2_kana: this.state.params.address_add_2_kana,
    };
    this.setState(
      {
        params: {
          ...this.state.params,
          ...params,
        },
      },
      () => {
        _.each(COPY_FIELD_ADDRESS_TARGET, input => {
          this.FormEventMg.trigger('input_change_value', {
            id: input,
            value: params[input],
          });
        });
        this.validateCopyFieldAddress();
      }
    );
  };

  clickSystemUseHistory = fieldId => {
    if (this.isRequestingFlag) {
      return;
    }
    this.isRequestingFlag = true;
    FieldServices.systemUseHistoryList(fieldId)
      .then(response => {
        if (!response.result) {
          console.error(
            'Fields.jsx',
            'clickSystemUseHistory',
            'FieldService.systemUseHistoryList !response.result',
            response
          );
          return;
        }
        this.setState({
          systemUseHistoryList: response.data.entities.contract_histories,
          visibleSystemUseHistoryDialog: true,
        });
      })
      .catch(error => {
        console.error(
          'Fields.jsx',
          'clickSystemUseHistory',
          'FieldService.systemUseHistoryList catch',
          error
        );
      })
      .finally(() => {
        this.isRequestingFlag = false;
      });
  };

  showDialogWarningDate = message => {
    if (!message) {
      ccusStore.destroy();
      _masterSlideLoader.show(this.state.beforePageReferer, {
        state: {},
      });
      return;
    }
    return dialogLoader.show(FormInformationDialog, {
      title: '注意事項',
      message,
      rootClassName: 'wide-dialog-md',
      onClose: () => {
        dialogLoader.close();
        ccusStore.destroy();
        _masterSlideLoader.show(this.state.beforePageReferer, {
          state: {},
        });
      },
    });
  };

  render() {
    const {
      validate,
      params,
      company,
      company_branch,
      jvsParams,
      beforePageReferer,
      isCcusRequiredShow,
      fieldCreatedAt,
      fieldUpdatedAt,
      companyName,
      disabledCooperationCcus,
      visibleSystemUseHistoryDialog,
      systemUseHistoryList,
      roanToChoseiFlg,
      ccusSecededFlag,
      isWarningGroundbreakingDate,
      isWarningCompleteScheduleDate,
    } = this.state;

    const managerHide =
      beforePageReferer === PAGE_REFERER.fields.key ||
      !isTargetRoleId([USER_ROLES.manager], this.role_id);
    return (
      <div id='slide-view' className='contruction-slide-view show FieldsForm'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 現場詳細・編集</title>
        </Helmet>

        <div className='contruction-slide-view__view'>
          <FormTopHeader
            beforePageReferer={beforePageReferer}
            close={() => {
              this.openCloseEditModal(beforePageReferer, true, roanToChoseiFlg);
            }}
            roanToChoseiFlg={roanToChoseiFlg}
            getTitleName={this.getTitleName}
          />

          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <FieldNaviList
                  fieldId={this.field_id}
                  selectedTab='FieldsDetail'
                  isEditable={true}
                  disabledCooperationCcus={disabledCooperationCcus}
                  showJvSettingTab={
                    beforePageReferer === PAGE_REFERER.fields.key ? true : false
                  }
                />
              </div>

              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <FormViewMenu
                  validate={validate}
                  checkValidate={this.checkValidate}
                  EventMg={this.FormEventMg}
                  role_id={this.role_id}
                  closeForm={() => {
                    this.openCloseEditModal(beforePageReferer, false, roanToChoseiFlg);
                  }}
                  params={params}
                  isCcusRequiredShow={isCcusRequiredShow}
                  disabledCheckbox={this.state.ccus_disable_checkbox}
                  ccusChecked={this.state.ccus_register_flg}
                  onChangeCcusCheckbox={this.onChangeCcusCheckbox}
                  onVisibleDialog={() =>
                    this.handleVisibleDialog(DIALOG_NAME.delete)
                  }
                  handleUpdate={this.handleUpdate}
                  isManager={!managerHide}
                  beforePageReferer={beforePageReferer}
                  getBeforePageName={this.getBeforePageName}
                  roanToChoseiFlg={roanToChoseiFlg}
                  ccusSecededFlag={ccusSecededFlag}
                />

                {(isWarningGroundbreakingDate ||
                  isWarningCompleteScheduleDate) && (
                  <DateDescriptionWarning
                    isWarningGroundbreakingDate={isWarningGroundbreakingDate}
                    isWarningCompleteScheduleDate={
                      isWarningCompleteScheduleDate
                    }
                  />
                )}

                <div className='contruction-detail-view__bar' />

                {/* ここからフォーム */}
                <div className='contruction-detail-view__main contruction-detail-view__main--fixed set-width-dropdown'>
                  <FormList>
                    <FieldCcusForm
                      ccusid={this.state.ccus_field_data.ccus_field_id}
                      fieldId={this.field_id}
                      setCcusFieldData={data => {
                        this.setCcusFieldData(data);
                      }}
                      updateFormValue={(key, value) => {
                        this.FormEventMg.trigger('input_change_value', {
                          id: key,
                          value,
                        });
                      }}
                      validate={validate}
                      setValidate={(validate, callback) => {
                        this.setState({ validate }, () => {
                          callback();
                        });
                      }}
                      fieldName={this.state.params.name}
                      ccusSecededFlag={ccusSecededFlag}
                    />
                    <Form EventMg={this.FormEventMg} submit={this.submit}>
                      {this.state.ccus_field_data.ccus_field_id && (
                        <FormEle.CcusId
                          defaultValue={
                            this.state.ccus_field_data.ccus_field_id
                          }
                        />
                      )}
                      <FormEle.CompanyName
                        defaultValue={company.company_name}
                      />

                      <FormEle.CompanyBranch
                        required
                        disabled
                        id='company_branch_id'
                        validate={validate.company_branch_id}
                        defaultValue={company_branch}
                        usersPartnerForm={false}
                        isRequireIconShow={true}
                      />

                      <FormEleCcus.FieldName
                        required
                        id='name'
                        maxLength={60}
                        defaultValue={params.name}
                        validate={validate.name}
                        ccusValue={this.state.ccus_field_data.field.name}
                      />
                      <FormEleCcus.FieldSelectCommon
                        id='ordering_type_id'
                        labelTitle={'発注区分'}
                        placeholder={'発注区分を指定'}
                        items={_.map(Object.keys(CCUS_ORDER_TYPE), item => {
                          return CCUS_ORDER_TYPE[item];
                        })}
                        defaultValue={params.ordering_type_id}
                        validate={validate.ordering_type_id}
                        ccusValue={
                          this.state.ccus_field_data.field.ordering_type_id
                        }
                        ccusRequired={
                          isCcusRequiredShow && this.state.ccus_register_flg
                        }
                        isFormListDefaultItem={true}
                      />
                      <FormEleCcus.FieldSelectCommon
                        id='construction_type_id'
                        labelTitle={'工事種類'}
                        placeholder={'工事種類を指定'}
                        items={_.map(
                          Object.keys(CCUS_CONSTRUCTURE_TYPE),
                          item => {
                            return CCUS_CONSTRUCTURE_TYPE[item];
                          }
                        )}
                        defaultValue={params.construction_type_id}
                        validate={validate.construction_type_id}
                        ccusValue={
                          this.state.ccus_field_data.field.construction_type_id
                        }
                        ccusRequired={
                          isCcusRequiredShow && this.state.ccus_register_flg
                        }
                        isFormListDefaultItem={true}
                      />
                      <FormListSubHeader
                        title={'現場情報'}
                        ccusComponent={
                          this.state.ccus_field_data.field.name !== undefined &&
                          this.state.ccus_field_data.field.name !== null &&
                          this.state.ccus_field_data.field.name !== '' && (
                            <CcusTitleBlock />
                          )
                        }
                      />
                      <FormEleCcus.FieldPostalCode
                        required
                        id='postal_code'
                        defaultValue={params.postal_code}
                        validate={validate.postal_code}
                        ccusValue={this.state.ccus_field_data.field.postal_code}
                        ccusRequired={
                          isCcusRequiredShow && this.state.ccus_register_flg
                        }
                      />
                      <FormEleCcus.FieldPrefecture
                        id='address_prefecture'
                        validate={validate.address_prefecture}
                        defaultValue={params.address_prefecture}
                        ccusValue={
                          this.state.ccus_field_data.field.address_prefecture
                        }
                        ccusRequired={
                          isCcusRequiredShow && this.state.ccus_register_flg
                        }
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_city'
                        labelTitle={'市区町村'}
                        placeholder={messageUtility.getMessage('I-000-190')}
                        maxLength={60}
                        validate={validate.address_city}
                        defaultValue={params.address_city || ''}
                        ccusValue={
                          this.state.ccus_field_data.field.address_city
                        }
                        ccusRequired={
                          isCcusRequiredShow && this.state.ccus_register_flg
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_city_kana'
                        labelTitle={'市区町村(フリガナ)'}
                        placeholder={messageUtility.getMessage('I-000-193')}
                        maxLength={60}
                        validate={validate.address_city_kana}
                        defaultValue={params.address_city_kana || ''}
                        ccusValue={
                          this.state.ccus_field_data.field.address_city_kana
                        }
                        ccusRequired={
                          isCcusRequiredShow && this.state.ccus_register_flg
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_add_1'
                        labelTitle={messageUtility.getMessage('I-000-189')}
                        placeholder={messageUtility.getMessage('I-000-192')}
                        maxLength={120}
                        validate={validate.address_add_1}
                        defaultValue={params.address_add_1}
                        ccusValue={
                          this.state.ccus_field_data.field.address_add_1
                        }
                        ccusRequired={
                          isCcusRequiredShow && this.state.ccus_register_flg
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_add_1_kana'
                        labelTitle={'その他1（フリガナ）'}
                        placeholder={messageUtility.getMessage('I-000-194')}
                        maxLength={120}
                        validate={validate.address_add_1_kana}
                        defaultValue={params.address_add_1_kana}
                        ccusValue={
                          this.state.ccus_field_data.field.address_add_1_kana
                        }
                        ccusRequired={
                          isCcusRequiredShow && this.state.ccus_register_flg
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_add_2'
                        labelTitle={'その他2（建物名など）'}
                        placeholder={'（例）赤坂ビルディング'}
                        maxLength={120}
                        validate={validate.address_add_2}
                        defaultValue={params.address_add_2}
                        ccusValue={
                          this.state.ccus_field_data.field.address_add_2
                        }
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_add_2_kana'
                        labelTitle={'その他2（フリガナ）'}
                        placeholder={'（例）アカサカビルディング'}
                        maxLength={120}
                        validate={validate.address_add_2_kana}
                        defaultValue={params.address_add_2_kana}
                        ccusValue={
                          this.state.ccus_field_data.field.address_add_2_kana
                        }
                      />
                      <FormListSubHeader
                        title={'事務所情報'}
                        ccusComponent={
                          this.state.ccus_field_data.field.name !== undefined &&
                          this.state.ccus_field_data.field.name !== null &&
                          this.state.ccus_field_data.field.name !== '' && (
                            <CcusTitleBlock />
                          )
                        }
                        info={
                          <button
                            className={`btn--sub`}
                            onClick={() => {
                              this.copyFieldAddress();
                            }}
                          >
                            現場住所の内容を転記する
                          </button>
                        }
                      />
                      <FormEleCcus.OfficePostalCode
                        required
                        id='office_postal_code'
                        defaultValue={params.office_postal_code}
                        validate={validate.office_postal_code}
                        ccusValue={
                          this.state.ccus_field_data.field.office_postal_code
                        }
                      />
                      <FormEleCcus.FieldPrefecture
                        id='office_address_prefecture'
                        validate={validate.office_address_prefecture}
                        defaultValue={params.office_address_prefecture || ''}
                        ccusValue={
                          this.state.ccus_field_data.field
                            .office_address_prefecture
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_city'
                        labelTitle={'市区町村'}
                        placeholder={messageUtility.getMessage('I-000-190')}
                        maxLength={60}
                        validate={validate.office_address_city}
                        defaultValue={params.office_address_city || ''}
                        ccusValue={
                          this.state.ccus_field_data.field.office_address_city
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_city_kana'
                        labelTitle={'市区町村(フリガナ)'}
                        placeholder={messageUtility.getMessage('I-000-193')}
                        maxLength={60}
                        validate={validate.office_address_city_kana}
                        defaultValue={params.office_address_city_kana}
                        ccusValue={
                          this.state.ccus_field_data.field
                            .office_address_city_kana
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_add_1'
                        labelTitle={messageUtility.getMessage('I-000-189')}
                        placeholder={messageUtility.getMessage('I-000-192')}
                        maxLength={120}
                        validate={validate.office_address_add_1}
                        defaultValue={params.office_address_add_1}
                        ccusValue={
                          this.state.ccus_field_data.field.office_address_add_1
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_add_1_kana'
                        labelTitle={'その他1（フリガナ）'}
                        placeholder={messageUtility.getMessage('I-000-194')}
                        maxLength={120}
                        validate={validate.office_address_add_1_kana}
                        defaultValue={params.office_address_add_1_kana}
                        ccusValue={
                          this.state.ccus_field_data.field
                            .office_address_add_1_kana
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_add_2'
                        labelTitle={'その他2（建物名など）'}
                        placeholder={'（例）赤坂ビルディング'}
                        maxLength={120}
                        validate={validate.office_address_add_2}
                        defaultValue={params.office_address_add_2}
                        ccusValue={
                          this.state.ccus_field_data.field.office_address_add_2
                        }
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_add_2_kana'
                        labelTitle={'その他2（フリガナ）'}
                        placeholder={'（例）アカサカビルディング'}
                        maxLength={120}
                        validate={validate.office_address_add_2_kana}
                        defaultValue={params.office_address_add_2_kana}
                        ccusValue={
                          this.state.ccus_field_data.field
                            .office_address_add_2_kana
                        }
                      />
                      <FormEleCcus.OfficeTell
                        required
                        id='tel'
                        defaultValue={params.tel}
                        validate={validate.tel}
                        ccusValue={this.state.ccus_field_data.field.tel}
                      />
                      <FormListSubHeader
                        title={'工期・労働時間情報'}
                        ccusComponent={
                          this.state.ccus_field_data.field.name !== undefined &&
                          this.state.ccus_field_data.field.name !== null &&
                          this.state.ccus_field_data.field.name !== '' && (
                            <CcusTitleBlock />
                          )
                        }
                      />
                      <FormEleCcus.GroundBreakingDate
                        required
                        id='groundbreaking_date'
                        defaultValue={params.groundbreaking_date}
                        validate={validate.groundbreaking_date}
                        ccusValue={
                          this.state.ccus_field_data.field.groundbreaking_date
                        }
                      />
                      <FormEleCcus.CompleteScheduleDate
                        required
                        id='complete_schedule_date'
                        defaultValue={params.complete_schedule_date}
                        validate={validate.complete_schedule_date}
                        ccusValue={
                          this.state.ccus_field_data.field
                            .complete_schedule_date
                        }
                      />
                      <FormEle.BuildeeEndDay
                        disabled={false}
                        value={params.usage_end_date}
                        validate={validate.usage_end_date}
                        onUpdate={value => {
                          const key = 'usage_end_date';
                          this.setState(
                            {
                              params: {
                                ...this.state.params,
                                [key]: value,
                              },
                            },
                            () => {
                              this.FormEventMg.trigger('input_change_value', {
                                id: key,
                                value,
                              });
                              this.eachValidate({
                                id: key,
                                params: this.state.params,
                              });
                            }
                          );
                        }}
                      />
                      <FormEle.WorkTimeType
                        name='WorkTimeType'
                        defaultValue={params}
                        validate={validate}
                        onChangeCheck={this.handleWorkHourZoneOnChangeCheck}
                      />
                      <FormEle.NestForm
                        defaultValue={params}
                        validate={validate}
                      />

                      <FormEle.DailyWorkTime
                        required
                        id='work_hour'
                        defaultValue={params.work_hour}
                        validate={validate.work_hour}
                      />
                      <FormListSubHeader
                        title={'管理者情報'}
                        ccusComponent={
                          this.state.ccus_field_data.field.name !== undefined &&
                          this.state.ccus_field_data.field.name !== null &&
                          this.state.ccus_field_data.field.name !== '' && (
                            <CcusTitleBlock />
                          )
                        }
                      />
                      <FormEle.ChiefName
                        required
                        id='charge_name'
                        maxLength={127}
                        defaultValue={params.charge_name}
                        validate={validate.charge_name}
                      />
                      <FormEle.ChiefFurigana
                        required
                        id='charge_name_kana'
                        maxLength={255}
                        defaultValue={params.charge_name_kana}
                        validate={validate.charge_name_kana}
                      />
                      {/* 現場監督の時は、表示しない */}
                      <SwitchForm show={managerHide}>
                        <FormEle.BuildeeTantousya
                          required
                          id='buildee_user_id'
                          defaultValue={params.buildee_user}
                          validate={validate.buildee_user_id}
                          isEdit={true}
                          fieldId={this.field_id}
                        />
                        <FormEle.BuildeeTantouEmail
                          defaultValue={
                            params.buildee_user
                              ? params.buildee_user.email
                              : null
                          }
                        />
                      </SwitchForm>
                      <FormEle.Department
                        id='department'
                        defaultValue={params.department}
                        validate={validate.department}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='manager_id'
                        labelTitle='CCUS管理者ID'
                        placeholder='（例）12345678901234'
                        maxLength={14}
                        defaultValue={params.manager_id}
                        validate={validate.manager_id}
                        ccusValue={
                          this.state.ccus_field_data.ccus_field_managers
                            .manager_id || ''
                        }
                        ccusRequired={
                          isCcusRequiredShow && this.state.ccus_register_flg
                        }
                      />
                      <FormListSubHeader title={'その他の設定'} />
                      <FormEle.StartDay
                        required
                        id='start_day'
                        defaultValue={params.start_day}
                        validate={validate.start_day}
                      />
                      <FormEle.ApprovalDays
                        required
                        id='approval_days'
                        defaultValue={params.approval_days}
                        validate={validate.approval_days}
                      />
                      <FormEle.UsePartnerCompanyApprovalFlag
                        id='use_partner_company_approval_flag'
                        defaultValue={params.use_partner_company_approval_flag}
                      />
                      {/* BLDE_V2-26961
                      <FormEle.PartnerInputResultFlag
                        id='partner_input_result_flag'
                        name='PartnerInputResultFlag'
                        defaultValue={params.partner_input_result_flag}
                        validate={validate.partner_input_result_flag}
                      />
                      */}
                      <FormEle.AdjustWorkPrintFlag
                        id='adjust_work_print_flag'
                        name='AdjustWorkPrintFlag'
                        defaultValue={params.adjust_work_print_flag}
                        validate={validate.adjust_work_print_flag}
                      />
                      <FormEle.CraneUsePrintFlag
                        id='crane_use_print_flag'
                        name='CraneUsePrintFlag'
                        defaultValue={params.crane_use_print_flag}
                        validate={validate.crane_use_print_flag}
                      />
                      <FormEle.WorkAndDiaryPrintFlag
                        id='work_and_diary_print_flag'
                        name='WorkAndDiaryPrintFlag'
                        defaultValue={params.work_and_diary_print_flag}
                        validate={validate.work_and_diary_print_flag}
                      />

                      <FormEle.ManagementNo
                        required
                        id='management_no'
                        defaultValue={params.management_no}
                        validate={validate.management_no}
                      />

                      {/* JV 追加フォーム */}
                      {beforePageReferer !== PAGE_REFERER.fields.key && (
                        <FormEle.JV
                          fieldsForm
                          id='jvs'
                          defaultValue={
                            _.isEmpty(params.jvs) ? null : params.jvs
                          }
                          validate={validate.jvs}
                          jvsParams={_.isEmpty(jvsParams) ? null : jvsParams}
                          companyBranchId={
                            !_.isUndefined(company_branch)
                              ? company_branch.id
                              : null
                          }
                        />
                      )}

                      <FieldFormElementsReadOnly
                        label={'登録日'}
                        value={moment(new Date(fieldCreatedAt)).format(
                          DATE_TIME_FORMAT.weekdaySlashDateTimeSecondFormat
                        )}
                      />
                      <FieldFormElementsReadOnly
                        label={'更新日'}
                        value={moment(new Date(fieldUpdatedAt)).format(
                          DATE_TIME_FORMAT.weekdaySlashDateTimeSecondFormat
                        )}
                      />

                      <FormListSubHeader title={'利用するサービス'} />
                      <FormEle.UseEntranceSystem
                        disabled={
                          this.state.params.changeable_entrance_flg === false
                        }
                        value={this.state.params.use_entrance_flg}
                        onUpdate={(value, params) => {
                          this.setState({
                            params: {
                              ...this.state.params,
                              use_entrance_flg: params,
                            },
                          });
                        }}
                      />
                      <FormEle.UseGreenFileSystem
                        disabled={
                          this.state.params.changeable_greenfile_flg === false
                        }
                        value={this.state.params.use_greenfile_flg}
                        onUpdate={(value, params) => {
                          this.setState({
                            params: {
                              ...this.state.params,
                              use_greenfile_flg: params,
                            },
                          });
                        }}
                        cannotOffGreenfileFlg={
                          this.state.params.cannot_off_greenfile_flg
                        }
                      />
                      {params.changeable_progress_flg && (
                        <FormEle.UseProgressSystem
                          disabled={false}
                          isUsingSpt={isApiFlagOn(params.use_spt_flg)}
                          value={this.state.params.use_progress_flg}
                          onUpdate={(value, params) => {
                            this.setState({
                              params: {
                                ...this.state.params,
                                use_progress_flg: params,
                              },
                            });
                          }}
                        />
                      )}

                      <FormEle.ContractorButton
                        fieldId={this.field_id}
                        onClickSystemUseHistory={this.clickSystemUseHistory}
                      />
                    </Form>

                    {/* 空間を開けるためのもの */}
                    <div className='tablet-spacer--400' />
                  </FormList>
                </div>

                <Modal modalRoot='root' modalState={this.state.showModal}>
                  <DialogSuccessError
                    msg={this.state.updateTitle}
                    msgDetail={this.state.updateMsg}
                    updateSuccess={this.state.updateSuccess}
                    success={() => {
                      const state = { ...this.state };
                      state.showModal = false;
                      this.setState(state);

                      if (state.ccus_register_flg === true) {
                        state.ccusRegisterDialogShow = true;
                        this.setState(state);
                      } else {
                        let messageDateDialog = '';
                        if (
                          state.isWarningGroundbreakingDate &&
                          state.isWarningCompleteScheduleDate
                        ) {
                          messageDateDialog = messageUtility.getMessage(
                            'W-000-023'
                          );
                        } else if (state.isWarningGroundbreakingDate) {
                          messageDateDialog = messageUtility.getMessage(
                            'W-000-021'
                          );
                        } else if (state.isWarningCompleteScheduleDate) {
                          messageDateDialog = messageUtility.getMessage(
                            'W-000-022'
                          );
                        }
                        this.setState({ messageDateDialog });
                        // BLDE_V2-48023 - 入退場管理機能がOFFからONに更新された場合、BANKEN案内ダイアログを表示
                        if (this.shouldShowBankenDialog()) {
                          this.handleVisibleDialog('banken');
                        } else {
                          this.showDialogWarningDate(messageDateDialog);
                        }
                      }
                    }}
                    error={() => {
                      // メッセージダイアログを閉じるときに更新ボタンのロックを解除
                      this.updatingFlag = false;
                      this.setState({ showModal: false });
                    }}
                    multilineText={true}
                  />
                </Modal>

                <CcusRegisterDialogProvider>
                  <FieldCcusRegisterDialog />
                </CcusRegisterDialogProvider>
              </div>
            </div>
          </div>
        </div>

        <SystemUseHistoryDialog
          visible={visibleSystemUseHistoryDialog}
          systemUseHistoryList={systemUseHistoryList}
          isUseProgressService={params.changeable_progress_flg}
          onClose={() => {
            this.setState({ visibleSystemUseHistoryDialog: false });
          }}
        />

        <Confirmation
          title='作業時間帯の設定を変更'
          visible={this.state.visibleDialogName === DIALOG_NAME.update}
          message={
            <React.Fragment>
              <div>作業時間帯の設定を変更しようとしています。</div>
              <div>
                チェックを外した作業時間帯は各種予定が登録出来なくなり、設定を戻す場合には施工体系図でも協力会社ごとに再設定が必要となります。
              </div>
              <div>よろしいですか？</div>
            </React.Fragment>
          }
          confirmButtonText={'更新'}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={() => {
            this.FormEventMg.trigger('submit');
          }}
          onCancel={() => this.handleVisibleDialog(null)}
        />
        <Confirmation
          visible={this.state.visibleDialogName === DIALOG_NAME.delete}
          title='現場申請を削除'
          message={`${companyName}を削除します。この作業は取り消せません。`}
          confirmButtonText={messageUtility.getMessage('I-000-018')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={this.fieldDelete}
          onCancel={() => this.handleVisibleDialog(null)}
          negativeButtonClassName='btn-fixedsize--negative'
          cancelButtonClassName='btn-fixedsize--sub'
          isNegative={true}
        />

        <Information
          title='作業時間帯を変更できません'
          message={
            <React.Fragment>
              <div>
                施工体系図で作業時間帯の設定がされていない協力会社が発生するため、1つ以上の作業時間帯を設定してください。
              </div>
            </React.Fragment>
          }
          buttonText={messageUtility.getMessage('I-000-008')}
          visible={this.state.workHourZoneOnChangeCheckDialogShow}
          buttonClassName='btn--sub'
          onClose={() => {
            this.setState({ workHourZoneOnChangeCheckDialogShow: false });
          }}
          multilineText={true}
        />
        <Information
          title={messageUtility.getMessage('I-002-004-01')}
          message={messageUtility.getMessage('I-002-004-02')}
          buttonText={messageUtility.getMessage('I-000-017')}
          visible={this.state.ccusRegisterDialogShow}
          onClose={() => {
            // BLDE_V2-48023 - CCUS登録開始後、BANKEN案内ダイアログを表示
            if (this.shouldShowBankenDialog()) {
              this.setState({ ccusRegisterDialogShow: false }, () => {
                this.handleVisibleDialog('banken');
              });
            } else {
              ccusStore.destroy();
              _masterSlideLoader.show(beforePageReferer, {
                state: {},
              });
            }
          }}
          multilineText={true}
        />
        <BankenInfoDialog
          visible={this.state.visibleDialogName === DIALOG_NAME.banken}
          onClose={() => {
            this.handleVisibleDialog(null);
            this.showDialogWarningDate(this.state.messageDateDialog);
          }}
        />
      </div>
    );
  }
}

/**
 * @description 一番上のヘッダー
 */
const FormTopHeader = ({ beforePageReferer, close, roanToChoseiFlg, getTitleName}) => {
  let title = getTitleName(roanToChoseiFlg, beforePageReferer);
  return (
    <MasterPageHeader
      title={
        <React.Fragment>
          <div className='contruction-slide-view__title'>{title}</div>
        </React.Fragment>
      }
      onClose={close}
    />
  );
};

/**
 * @description リンク部分
 */
const FormHeader = ({
  beforePageReferer,
  closeForm,
  errorStyle,
  counter,
  total,
  roanToChoseiFlg,
  getBeforePageName,
}) => {
  let title = getBeforePageName(roanToChoseiFlg, beforePageReferer);
  return (
    <div className='contruction-detail-view__header'>
      <button className='btn-text--sm' onClick={closeForm}>
        <i className='i-back--blue i-2x vertical-middle' />
        {title}
      </button>

      <div className='contruction-detail-view__header__messages'>
        <div style={errorStyle}>入力エラーがあります。</div>
        {` 必須項目の入力数 ${counter}/${total}`}
      </div>
    </div>
  );
};

/**
 * @description ビューメニュー
 *              イベントを受け取るのでここは React.Component にする
 */
class FormViewMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      num: 0, // 必須項目入力数
      isCcusRequiredShow: true, // 「入力した内容をCCUSにも登録する」の表示フラグ
      validate: {},
      params: {},
      workhour_values: {},
    };
    // 必須項目ステータス
    this.requiredList_base = {
      company_branch_id: false, // 支店
      name: false, // 現場名
      address_prefecture: false, //都道府県
      address_city: false, //市区町村
      address_city_kana: false, //市区町村(フリガナ)
      address_add_1: false, //その他1（丁目・番地など）
      address_add_1_kana: false, //その他1フリガナ
      office_postal_code: false, // 事務所郵便番号
      office_address_prefecture: false, //都道府県
      office_address_city: false, //市区町村
      office_address_city_kana: false, //市区町村(フリガナ)
      office_address_add_1: false, //その他1（丁目・番地など）
      office_address_add_1_kana: false, //その他1フリガナ
      charge_name: false, // 所長名
      charge_name_kana: false, // 所長名フリガナ
      tel: false, // 事務所電話番号
      buildee_user_id: false, // Buildee担当者
      groundbreaking_date: false, // 着工日
      complete_schedule_date: false, // 竣工予定日
      //1日あたりの労働時間
      work_hour: false,
      work_hour_zone_day_flag: false,
      work_hour_zone_night_flag: false,
      work_hour_zone_midnight_flag: false,
      usage_end_date: false, // Buildee利用終了日
      start_day: false, // 月次開始日
      approval_days: false, // 自動ロックまでの日数
      management_no: false, // 工事管理番号
      work_hour_type: false,
    };

    //ccus登録用バリデート必須項目
    this.requiredList_ccus = {
      postal_code: false, // 現場郵便番号
      ordering_type_id: false,
      construction_type_id: false,
      manager_id: false,
    };

    this.role_id = props.role_id; // ロールID
    this.isCcusRequiredShow = props.isCcusRequiredShow;

    this.requiredList = _.assign(
      {},
      this.requiredList_base,
      this.props.ccusChecked ? this.requiredList_ccus : {}
    );

    if (this.props.isManager) {
      delete this.requiredList.buildee_user_id; // 現場監督の時は消す
    }
    this.work_hours_keys = [
      'work_copy_time',
      'work_end_time',
      'work_start_time',
      'earlytime_end',
      'overtime_start',
    ];
    this.EventMg = props.EventMg;
    this.EventMg.addEventListener('change_value', (id, params) => {
      if (!Object.keys(params).length) {
        return;
      }
      const workhour_values = { ...this.state.workhour_values };
      _.each(this.work_hours_keys, key => {
        if (params[key]) {
          workhour_values[key] = params[key];
        }
        const key_night = `${key}_night`;
        if (params[key_night]) {
          workhour_values[key_night] = params[key_night];
        }
        const key_midnight = `${key}_midnight`;
        if (params[key_midnight]) {
          workhour_values[key_midnight] = params[key_midnight];
        }
      });
      this.setState({ workhour_values }, () => {
        if (params.work_hour_zone_day_flag) {
          _.each(this.work_hours_keys, key => {
            if (workhour_values[key]) {
              params[key] = params[key] || workhour_values[key];
            }
          });
        }
        if (params.work_hour_zone_night_flag) {
          _.each(this.work_hours_keys, key => {
            const key_night = `${key}_night`;
            if (workhour_values[key_night]) {
              params[key_night] =
                params[key_night] || workhour_values[key_night];
            }
          });
        }
        if (params.work_hour_zone_midnight_flag) {
          _.each(this.work_hours_keys, key => {
            const key_midnight = `${key}_midnight`;
            if (workhour_values[key_midnight]) {
              params[key_midnight] =
                params[key_midnight] || workhour_values[key_midnight];
            }
          });
        }
        this.validateParams(params);
      });
      this.EventMg.trigger('update_validate', { id, params });
    });
  }

  validateWorkZoneHours = (params, result) => {
    const WORK_ZONE_HOURS_FLAG = {
      DAY_FLAG: params.work_hour_zone_day_flag === 1,
      NIGHT_FLAG: params.work_hour_zone_night_flag === 1,
      MIDNIGHT_FLAG: params.work_hour_zone_midnight_flag === 1,
    };

    WORK_ZONE_HOURS_FLAG.DAY_FLAG
      ? (this.requiredList.work_hour_zone_day_flag = false)
      : delete this.requiredList.work_hour_zone_day_flag;
    WORK_ZONE_HOURS_FLAG.NIGHT_FLAG
      ? (this.requiredList.work_hour_zone_night_flag = false)
      : delete this.requiredList.work_hour_zone_night_flag;
    WORK_ZONE_HOURS_FLAG.MIDNIGHT_FLAG
      ? (this.requiredList.work_hour_zone_midnight_flag = false)
      : delete this.requiredList.work_hour_zone_midnight_flag;
    if (WORK_ZONE_HOURS_FLAG.DAY_FLAG) {
      _.each(this.work_hours_keys, key => {
        if (result.messages[key]) {
          result.messages.work_hour_zone_day_flag = '必須です。';
          return false;
        }
      });
    } else {
      delete result.messages.work_hour_zone_day_flag;
    }
    if (WORK_ZONE_HOURS_FLAG.NIGHT_FLAG) {
      _.each(this.work_hours_keys, key => {
        const k = `${key}_night`;
        if (result.messages[k]) {
          result.messages.work_hour_zone_night_flag = '必須です。';
          return false;
        }
      });
    } else {
      delete result.messages.work_hour_zone_night_flag;
    }
    if (WORK_ZONE_HOURS_FLAG.MIDNIGHT_FLAG) {
      _.each(this.work_hours_keys, key => {
        const k = `${key}_midnight`;
        if (result.messages[k]) {
          result.messages.work_hour_zone_midnight_flag = '必須です。';
          return false;
        }
      });
    } else {
      delete result.messages.work_hour_zone_midnight_flag;
    }
  };

  validateParams = (params, ccusChecked) => {
    let result = validationByJoi(
      (ccusChecked !== undefined
      ? ccusChecked
      : this.props.ccusChecked)
        ? FieldCcusScheme
        : FieldScheme,
      params
    );
    result = this.props.checkValidate(result, params);
    this.setState({ validate: result.messages, params }, () => {
      this.validateWorkZoneHours(params, result);
      this.setState({ validate: result.messages });
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.ccusChecked !== prevProps.ccusChecked) {
      this.requiredList = _.assign(
        {},
        this.requiredList_base,
        this.props.ccusChecked ? this.requiredList_ccus : {}
      );
      this.validateParams(this.state.params, this.props.ccusChecked);
    }
    if (this.props.params !== prevState.params) {
      this.setState({ params: this.props.params });
    }
  }

  render() {
    const result = _.pick(this.state.validate, _.keys(this.requiredList));
    const validateResult = _.omit(this.requiredList, _.keys(result));
    const counter = _.size(_.keys(validateResult));
    const total = _.size(this.requiredList);
    const jvsError = _.has(this.state.validate, 'jvs');
    const error_style =
      _.isEmpty(this.props.validate) || (counter === total && !jvsError)
        ? { display: 'none' }
        : { color: 'red', fontSize: '15px' };
    const { beforePageReferer, roanToChoseiFlg, closeForm } = this.props;

    return (
      <React.Fragment>
        <FormHeader
          beforePageReferer={beforePageReferer}
          closeForm={closeForm}
          errorStyle={error_style}
          counter={counter}
          total={total}
          roanToChoseiFlg={roanToChoseiFlg}
          getBeforePageName={this.props.getBeforePageName}
        />

        <div className='contruction-detail-view__menu'>
          <span className='construction-detail-view__button'>
            <button className='btn--sub' onClick={this.props.closeForm}>
              編集をやめる
            </button>
          </span>
          <span className='construction-detail-view__button'>
            <button
              className='btn--effective'
              onClick={this.props.handleUpdate}
            >
              更新
            </button>
          </span>
          {!this.isCcusRequiredShow && (
            <span className='construction-detail-view__button'>
              <button
                className='btn--negative'
                onClick={this.props.onVisibleDialog}
              >
                削除
              </button>
            </span>
          )}

          {this.isCcusRequiredShow && !this.props.disabledCheckbox && (
            <span className='construction-detail-view__button'>
              <FieldFormCcusCheckbox
                checked={this.props.ccusChecked}
                disabled={
                  this.props.disabledCheckbox || this.props.ccusSecededFlag
                }
                onChange={this.props.onChangeCcusCheckbox}
                ccusSecededFlag={this.props.ccusSecededFlag}
              />
            </span>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const DateDescriptionWarning = ({
  isWarningGroundbreakingDate,
  isWarningCompleteScheduleDate,
}) => {
  return (
    <React.Fragment>
      {isWarningGroundbreakingDate && (
        <div className='contruction-detail-view__attention'>
          <Description type='primary'>
            <a
              className='clickable-text'
              onClick={() => scrollToElem('groundbreaking_date')}
            >
              着工日
            </a>
            {messageUtility.getMessage('W-000-025')}
          </Description>
        </div>
      )}
      {isWarningCompleteScheduleDate && (
        <div className='contruction-detail-view__attention'>
          <Description type='primary'>
            <a
              className='clickable-text'
              onClick={() => scrollToElem('complete_schedule_date')}
            >
              竣工予定日
            </a>
            {messageUtility.getMessage('W-000-024')}
          </Description>
        </div>
      )}
    </React.Fragment>
  );
};

const data = {
  pageTitle: {
    fieldEdit: '現場編集',
    fieldDetail: '現場詳細',
    fieldRequestEdit: '現場申請編集',
    fieldRequestDetail: '現場申請詳細',
  },
};



// WEBPACK FOOTER //
// ./src/pages/FieldsForm.jsx